import React from 'react';

export const RedUnefon2 = () => {
  return (
    <>
         <div className='unefon2'></div>
        <div className="txtRedes1">Todos los paquetes mostrados incluyen Minutos, Mensajes y WhatsApp ilimitado</div>
     </>  
  )
}
